module.exports = __webpack_public_path__ + "img/20231221.6dd06c35.jpeg";